module.exports = __webpack_public_path__ + "img/yan1.66c1e3fb.png";